import React, { useCallback, useState } from 'react';

import Image from 'next/image';

import { Loader } from '@atoms';

import classes from './lazy-image.module.scss';

type LazyImageProps = {
  className?: string;
  url: string;
  onClick?: () => any;
  unoptimized?: boolean;
  priority?: boolean;
};

export const LazyImage = ({
  className,
  url,
  onClick,
  unoptimized,
  priority,
}: LazyImageProps) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const onImageClick = useCallback(() => {
    onClick && onClick();
  }, [onClick]);

  return (
    <div className={className} onClick={onImageClick}>
      {!imageLoaded && <Loader className={classes.imageLoader} />}
      <Image
        onLoadingComplete={() => setImageLoaded(true)}
        layout="fill"
        objectFit="cover"
        quality={100}
        src={url}
        unoptimized={unoptimized}
        priority={priority}
      />
    </div>
  );
};
